/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file.
 */

export default [
  // Home
  {
    path: '/',
    name: 'home.index',
    component: () => import('@/pages/Home.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },

  // Digital Media
  {
    path: '/digital-media',
    name: 'digitalMedia.index',
    component: () => import('@/pages/DigitalMedia.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },

  // Physical Media
  {
    path: '/physical-media',
    name: 'physicalMedia.index',
    component: () => import('@/pages/PhysicalMedia.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },

  // Social Media
  {
    path: '/social-media',
    name: 'socialMedia.index',
    component: () => import('@/pages/SocialMedia.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },

  // About Us
  {
    path: '/about-us',
    name: 'aboutUs.index',
    component: () => import('@/pages/AboutUs.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },

  // Contact Us
  {
    path: '/contact-us',
    name: 'contactUs.index',
    component: () => import('@/pages/ContactUs.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },

  // Heroes of Legend
  {
    path: '/hol',
    name: 'hol.index',
    component: () => import('@/pages/hol/Home.vue'),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  {
    path: '/p2toolbox/',
    redirect: '/p2toolbox/',
  },
  {
    path: '/p2etoolbox/',
    redirect: '/p2etoolbox/',
  },

  // Portfolio
  // {
  //   path: '/portfolio',
  //   name: 'portfolio.index',
  //   component: () => import('@/pages/Portfolio.vue'),

  //   // If the user needs to be authenticated to view this page
  //   meta: {
  //     auth: false,
  //   },
  // },

  // Account
  // {
  //   path: '/account',
  //   name: 'account.index',
  //   component: () => import('@/pages/Account/Index.vue'),

  //   // If the user needs to be authenticated to view this page.
  //   meta: {
  //     auth: true,
  //   },
  // },

  // Login
  // {
  //   path: '/login',
  //   name: 'login.index',
  //   component: () => import('@/pages/Login/Index.vue'),

  //   // If the user needs to be a guest to view this page.
  //   meta: {
  //     guest: true,
  //   },
  // },

  // Register
  // {
  //   path: '/register',
  //   name: 'register.index',
  //   component: () => import('@/pages/Register/Index.vue'),

  //   // If the user needs to be a guest to view this page.
  //   meta: {
  //     guest: true,
  //   },
  // },

  // Typography
  // {
  //   path: '/typography',
  //   name: 'typography.index',
  //   component: () => import('@/pages/Typography.vue'),

  //   // If the user needs to be a guest to view this page.
  //   meta: {
  //     guest: true,
  //   },
  // },

  // Article landing page section
  // 3/25/19 article about email marketing campaigns
  {
    path: '/articles/Mar2519',
    name: 'Mar2519.index',
    component: () => import('@/pages/Articles/emailMarketing-3-25-19.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      guest: true,
    },
  },
  // 3/31/19 article about World Recovery Day
  {
    path: '/articles/Mar3119',
    name: 'Mar3119.index',
    component: () => import('@/pages/Articles/world-recovery-day-mar3119.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      guest: true,
    },
  },

  // 404
  {
    path: '/404',
    name: '404.index',
    component: () => import('@/pages/404.vue'),

    // If the user needs to be a guest to view this page.
    meta: {
      guest: true,
    },
  },
  {
    path: '/*',
    redirect: '/404',
  },
];
